/**
 * @fileoverview O acesso restrito (31/10/2026, etapa 9 dos planos): a Empresa
 * passou dos limites do plano sem a escolha do que fica. Até a escolha, quem
 * cuida da cobrança só usa Faturamento (as outras telas mostram o caminho até
 * lá) e os demais veem o aviso para falar com o administrador. O servidor já
 * recusa as ações fora de Faturamento: aqui a tela só reflete. O super passa.
 */

import React from "react";
import { Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory, useLocation } from "react-router-dom";

import { useBilling } from "../../../context/Billing/BillingContext";
import { i18n } from "../../../translate/i18n";
import { tokens } from "../../Triage/styles";

const t = (key, options) => i18n.t(`restrictedAccess.${key}`, options);

const BILLING_PATH = "/settings/billing";

const useStyles = makeStyles((theme) => {
  const dark = theme.palette.type === "dark";
  const c = tokens(dark);
  const text = dark ? "#f8fafc" : "#111827";
  return {
    wrap: { display: "flex", justifyContent: "center", padding: theme.spacing(6, 2) },
    card: { maxWidth: 520, padding: theme.spacing(3.5), borderRadius: 12, background: c.surface, border: `1px solid ${c.border}`, display: "flex", flexDirection: "column", gap: 12 },
    title: { margin: 0, fontSize: "1.15rem", fontWeight: 700, color: text },
    text: { margin: 0, fontSize: "0.92rem", lineHeight: 1.6, color: c.textSecondary },
    action: {
      alignSelf: "flex-start",
      height: 40,
      padding: "0 18px",
      borderRadius: 10,
      border: "none",
      background: "#3D5CFD",
      color: "#fff",
      fontFamily: "inherit",
      fontSize: 14,
      fontWeight: 700,
      cursor: "pointer",
      "&:focus-visible": { outline: "none", boxShadow: `0 0 0 1px ${dark ? "#fff" : "#09090B"}` },
    },
  };
});

const RestrictedAccessGate = ({ managesBilling, isSuper, children }) => {
  const classes = useStyles();
  const { billing } = useBilling();
  const history = useHistory();
  const location = useLocation();

  const restricted = billing?.adequacyRequired === true && !isSuper;
  if (!restricted) return children;
  if (managesBilling && location.pathname.startsWith(BILLING_PATH)) return children;

  return (
    <div className={classes.wrap}>
      <Paper elevation={0} className={classes.card} role="alert">
        <h1 className={classes.title}>{t("title")}</h1>
        <p className={classes.text}>{managesBilling ? t("textAdmin") : t("textMember")}</p>
        {managesBilling && (
          <button type="button" className={classes.action} onClick={() => history.push(BILLING_PATH)}>
            {t("action")}
          </button>
        )}
      </Paper>
    </div>
  );
};

export default RestrictedAccessGate;
